<!-- Modal Backdrop -->
@if (isOpen()) {
<div
  class="modal-backdrop fixed inset-0 flex items-center justify-center z-50 transition-all duration-300 ease-out"
  [class.bg-gray-950/50]="isAnimating()"
  [class.bg-gray-950/0]="!isAnimating()"
  (click)="closeModal()"
>
  <!-- Modal Container -->
  <div
    class="modal-container bg-white rounded-lg shadow-xl w-full max-w-sm sm:max-w-md lg:max-w-2xl xl:max-w-4xl mx-4 sm:mx-6 lg:mx-8 transform transition-all duration-300 ease-out overflow-hidden"
    [class.scale-100]="isAnimating()"
    [class.opacity-100]="isAnimating()"
    [class.scale-95]="!isAnimating()"
    [class.opacity-0]="!isAnimating()"
    [class.translate-y-0]="isAnimating()"
    [class.translate-y-4]="!isAnimating()"
    (click)="$event.stopPropagation()"
  >
    <!-- Modal Header -->
    <div class="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200">
      <h3 class="text-base sm:text-lg lg:text-xl font-semibold text-gray-900">Ver Calificaciones</h3>
      <button
        (click)="closeModal()"
        class="text-gray-400 hover:text-gray-600 transition-colors p-1 sm:p-2"
      >
        <i class="fas fa-times text-lg sm:text-xl"></i>
      </button>
    </div>
    <!-- Modal Body -->
    <div class="p-4 sm:p-6 overflow-y-auto flex flex-col sm:flex-row gap-3 sm:gap-4 lg:gap-6 max-h-[70vh] sm:max-h-[80vh]">
      <!-- No ratings message -->
      @if (!data.isCommentEstablishment) {
        <div class="flex-1 w-full sm:w-1/2">
          <comment-estblishment
            [shopingCart]="data.shoppingCart"
            (FormSend)="onFormSent($event)"
          ></comment-estblishment>
        </div>
      }
      @if(!data.isCommentDelivery ){
        <div class="flex-1 w-full sm:w-1/2">
          <comment-delivery
            [shopingCart]="data.shoppingCart"
            (FormSend)="onFormSent($event)"
          ></comment-delivery>
        </div>
      }

    </div>

    <!-- Modal Footer -->

  </div>
</div>
}
